<template>
  <x-card style="height: 100%;">
    <x-card-title class="mx-md-5">
      <div class="d-flex">
        <h3>Referee Report Form</h3>

        <!-- <div v-if="step === 1" class="d-flex d-md-none ml-md-0 ml-auto">
          <x-button color="primary" @click="step--" :disabled="step === 1">Back</x-button>
          <x-button class="ml-5" color="primary" @click="step++" :disabled="step ===3">Next</x-button>
        </div> -->
      </div>


    </x-card-title>

    <v-divider />

    <x-card-text>
      <v-window v-model="step">
        <v-window-item :value="1">
          <x-card class="rounded-lg" style="border: 1px solid #c49a28; padding: 2rem;">
            <x-card-text>
              <div class="d-flex">
                <h3 style="color: #c49a28">Referee Information</h3>
                <h3 class="d-md-flex ml-auto d-none" style="color: #c49a28">Referee 1 of 2</h3>
            </div>
            <hr class="my-10"/>


            <div class="mt-4 mx-md-1 mx-0">
              <div>
                <v-row>
                  <v-col cols="12" md="8">
                    <v-text-field dense placeholder="Name" outlined/>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-select dense placeholder="Select Role" outlined/>
                  </v-col>
                </v-row>
              </div>

              <div>
                <v-row >
                  <v-col cols="12" md="5">
                    <v-text-field placeholder="Organization" dense outlined/>
                  </v-col>

                  <v-col cols="12" md="7">
                    <v-text-field placeholder="Address" dense outlined/>
                  </v-col>
                </v-row>
              </div>

              <div>

                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field placeholder="Email" dense outlined/>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-text-field placeholder="Phone" dense outlined/>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-text-field placeholder="Signature" dense outlined/>
                  </v-col>
                </v-row>
              </div>

            </div>
            </x-card-text>

          </x-card>


        </v-window-item>

        <v-window-item :value="2">
          <div class="d-flex">
            <h3 style="color: #c49a28">To be completed by Referee</h3>
            <h3 class="ml-md-auto d-none" style="color: #c49a28">Referee One (1)</h3>
          </div>
          
          <v-divider class="my-5"/>

          <div class="mx-4">
            <div>
                <p>How long have and in what capacity have you known the candidate?</p>
                <v-textarea placeholder="Type something here between 200 - 250" outlined/>
            </div>

            <div class="my-5">
              <v-row>
                <v-col cols="12" md="4">
                  <div class="d-md-flex d-block align-center">
                  <p style="font-size: 12px;">Intellectual Capacity:</p>
                  <v-select outlined dense/>
                </div>
                </v-col>


                <v-col cols="12" md="4">
                  <div class="d-md-flex d-block align-center">
                    <p style="font-size: 12px;">Capacity for Persistent and Independent Academic Study</p>
                    <v-select outlined dense/>
                  </div>
                </v-col>

                <v-col cols="12" md="4">
                  <div class="d-md-flex d-block align-center">
                    <p style="font-size: 12px;">Ability for Imagine Thought:</p>
                    <v-select outlined dense/>
                  </div>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="4">
                  <div class="d-md-flex d-block align-center">
                    <p style="font-size: 12px">Promise for Productivity: </p>
                    <v-select outlined dense/>
                  </div>
                </v-col>


                <v-col cols="12" md="4">
                  <div class="d-md-flex d-block align-center">
                    <p style="font-size: 12px">Quality of Previous Work:</p>
                    <v-select outlined dense/>
                  </div>
                </v-col>

                <v-col cols="12" md="4">
                  <div class="d-md-flex d-block align-center">
                    <p style="font-size: 12px;">Oral and Written Expression in English:</p>
                    <v-select outlined dense/>
                  </div>
                </v-col>


              </v-row>

              <v-row>
                <v-col cols="12" md="4">
                  <div class="d-md-flex d-block align-center">
                    <p style="font-size: 12px;">Overall Promise:</p>
                    <v-select outlined dense/>
                  </div>
                </v-col>

              </v-row>
            </div>




          </div>
            
          <div class="mx-4">
            <p>Please comment on the Candidate’s personality (Bearing in Mind Moral Character, Emotional and Physical Stability):</p>
            <v-textarea outlined placeholder="Type something between 200 - 250"/>
          </div>
         

          <div class="d-md-flex d-block" style="gap: 2rem">
            <div  style="border: 1px solid #c49a28; border-radius: 1rem; padding: 1rem;">
              <div class="d-flex">
                <p>
                  Should the situation arise, would you accept the candidate as a research student?
                </p>

                <v-radio-group row dense>
                  <div class="d-flex">
                    <v-radio label="Yes"/>
                    <v-radio label="No"/>
                  </div>

                </v-radio-group>
              </div>

            </div>

            <div class="" style="border: 1px solid #c49a28; border-radius: 1rem; padding: 1rem;" :style="[isMobile ? { marginTop: '2rem', } : { gap: '' }]"> 
              <div class="d-flex">
                <p>Any other relevant information which would  help in determining the candidate’s sustainability for postgraduate studies?</p>
              

                <v-radio-group row dense>
                  <div class="d-flex">
                    <v-radio label="Yes" />
                    <v-radio label="No"/>
                  </div>

                </v-radio-group>
              </div>

            </div>
          </div>
          
          
          <div class="d-md-flex d-block my-10 justify-end ml-auto align-center">
            <x-button color="primary" @click="step--" :disabled="step === 1">Back</x-button>
            
              <x-button class="ml-5" color="primary" @click="step++" :disabled="step ===3">Next</x-button>
              <x-button class="d-flex mt-md-0 mt-5 ml-md-5">Add second Referee details</x-button>
          </div>

        </v-window-item>

        <v-window-item :value="3">
          <div style="display: grid; place-content: center;">
            <div style="margin-top: 5rem;">
              <h2 class="text-center">You have already filled in your referee details.</h2>
              <h2 class="pt-3">Here is a status of the respondents</h2>
            </div>


            <div class="mt-10">
              <v-row>
                <v-col cols="12" md="12">
                  <v-row>
                    <v-col>
                      <div>Referee name</div>
                    </v-col>

                    <v-col>
                      <div class="">Status</div>
                    </v-col>
                  </v-row>
                  <v-divider />
                </v-col>


                <v-col cols="12" md="12">
                  <v-row>
                    <v-col>
                      <p class="pt-2">Jude Gabriel</p>
                      <p class="pt-3">Idris Olaekan</p>
                    </v-col>

                    <v-col>
                      <div class="d-flex align-center">
                        <v-avatar size="30" color="primary">
                          <v-icon color="white">mdi-check</v-icon>
                        </v-avatar>
                        <p class="ml-3 pt-2" style="color: #c49a28; font-size: 12px">Responded</p>
                      </div>


                      <div class="d-flex align-center">
                        <img  src="../../../../../public/img/lafia/Ellipse.svg" width="30px" contain height="auto"  aspect-ratio="1"/>
                        <p class="ml-3 pt-3" style="color: #c49a28; font-size: 12px">Not Responded</p>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
             
            </div>
          </div>


        </v-window-item>
      </v-window>
    </x-card-text>
  

    <v-card-actions>
      <div class="d-flex ml-auto" v-if="step === 1 || step === 3">
        <x-button color="primary" @click="step--" :disabled="step === 1">Back</x-button>
        <x-button class="ml-5" color="primary" @click="step++" :disabled="step ===3">Next</x-button>
      </div>

      <div v-else>

      </div>

    </v-card-actions>

    <loading-dialog />
  </x-card>
</template>


<script>
import LoadingDialog from "@ui/components/LoadingDialog.vue";
import XButton from '@ui/widgets/XButton.vue';
import XCard from '@ui/components/XCard.vue';
import XTextField from '@ui/widgets/XTextField.vue';
import XCardText from '@ui/components/XCardText.vue';
import XCardTitle from '@ui/components/XCardTitle.vue';

export default {
  name: "Referee", 
  components: {
    LoadingDialog, 
    XButton, 
    XCard, 
    XTextField, 
    XCardText,
    XCardTitle
  }, 

  data: () => ({
    step: 1,
  }), 

  computed: {
    isMobile: function () {
      return this.$vuetify.breakpoint.smAndDown
    },
  }
}
</script>